export const SEARCH_MODE_STATIC = 'static'
export const SEARCH_MODE_DYNAMIC = 'dynamic'
export const searchModes = [SEARCH_MODE_STATIC, SEARCH_MODE_DYNAMIC]
